import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  startGettingRolesList,
  setRolesList,
  startAddNewRole,
  completedFetch,
  completedNewAdd,
  startRolesListByUserId,
  setUserRolesList,
  startGettingFilterRolesList,
  setRolesFilterList,
  startDeleteRolesList,
  startAddUserRolesList,
} from "./roles.slice.selector";
import { setNotificationAction } from "../NotificationStore/notification.slice.selector";
import {
  addNewRole,
  getUserRolesByUserId,
  getAllRoles,
  getFilterAllRoles,
  getDeleteAllRoles,
  addUserRoles,
} from "../../../Apis/Roles/roles";
//(1) Watcher
function* startFetchRolesList() {
  yield takeLatest(startGettingRolesList.type, setRolesListData);
}
//(1) Next
function* setRolesListData({ payload }) {
  try {
    const response_data = yield call(getAllRoles, payload);

    yield put(setRolesList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(1.5) Watcher
function* startFetchFilterRolesList() {
  yield takeLatest(startGettingFilterRolesList.type, setFilteredRolesListData);
}
//(1.5) Next
function* setFilteredRolesListData({ payload }) {
  try {
    const response_data = yield call(getFilterAllRoles, payload);

    yield put(setRolesFilterList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2)Wacther
function* startAddingNewRoles() {
  yield takeLatest(startAddNewRole.type, callForAddingNewRole);
}
//(2)Next
function* callForAddingNewRole({ payload }) {
  try {
    const { tableData, data } = payload;
    yield call(addNewRole, data);
    yield put(completedNewAdd());
    yield put(setNotificationAction({
      message: "User Added Successfully",
      variant: "success",
    })
    );
    yield put(startGettingRolesList(tableData));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );

  }
}

//(3) Watcher
function* startFetchUserRolesList() {
  yield takeLatest(startRolesListByUserId.type, setuserRolesListData);
}
//(3) Next
function* setuserRolesListData({ payload }) {
  try {
    const response_data = yield call(getUserRolesByUserId, payload);

    yield put(setUserRolesList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(4) Watcher
function* startDeleteRolesListData() {
  yield takeLatest(startDeleteRolesList.type, setDeleteListData);
}
//(4) Next
function* setDeleteListData({ payload }) {
  try {
    const response_data = yield call(getDeleteAllRoles, payload);
    startGettingRolesList()
    yield put(completedFetch());
    yield put(startGettingRolesList({
      pageIndex: 0,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(5) Watcher
function* startAddUserRolesListData() {
  yield takeLatest(startAddUserRolesList.type, setAddUserR);
}
//(5) Next
function* setAddUserR({ payload }) {
  try {
    const response_data = yield call(addUserRoles, payload);
    startGettingRolesList()
    yield put(completedFetch());
    yield put(startGettingRolesList({
      pageIndex: 0,
      pageSize: 10,
    }));
    yield put(
      setNotificationAction({
        message: "User Role Added",
        variant: "success",
      })
    );
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

///Accumulator
export default function* rolesSaga() {
  yield all([
    call(startFetchRolesList),
    call(startFetchFilterRolesList),
    call(startAddingNewRoles),
    call(startFetchUserRolesList),
    call(startDeleteRolesListData),
    call(startAddUserRolesListData),
  ]);
}
